export const CARD_TEST_ID = 'card';
